import React, { useState } from 'react'
import styles from './GameActionsRow.module.css'
// import GameActionButton from '../GameActionButton/GameActionButton'
import { GameActionButton } from '@themed-components'
import { ALL_IN_ACTION, AUTO_CALL_ACTION, AUTO_CALL_ANY_ACTION, AUTO_CHECK_ACTION, AUTO_CHECK_OR_FOLD_ACTION, AUTO_FOLD_ACTION, CALL_ACTION, CHECK_ACTION, FOLD_ACTION, RAISE_ACTION } from '@/Poker/data/Constants'
import { 
  usePlayerSeat as useGamePlayerSeat,
  useShowFold,
  useShowCheck,
  useShowCall,
  useShowRaise,
  useShowAllIn,
  useCallAmount,
  useRaiseAmount,
  useShowDefaultActions,
  usePlayerSitOutTimer,
  useRITRequest,
  useShowAutoActions,
  useAutoCall,
  useAutoCallAny,
  useAutoFold,
  useAutoCheck,
  useAutoCheckOrFold,
  useAutoAction,
  useTourneyAutoPlay
} from '@/src/hooks/data/useGameTable'
import usePlayerSeat from '@/src/hooks/data/usePlayerSeat'
import SitOutBottomNotice from '../SitOutBottomNotice/SitOutBottomNotice'
import RITRequestComponent from '../RITRequest/RITRequest'
// import AutoActionButton from '../AutoActionButton/AutoActionButton'
import { AutoActionButton } from '@themed-components'
// import WatchTimer from '../WatchTimer/WatchTimer'
import { WatchTimer } from '@themed-components';
import TourneyAutoPlayCTA from '../TourneyAutoPlayCTA/TourneyAutoPlayCTA'
import PlayNext from '../PlayNext/PlayNext'

export default function GameActionsRow({ tempTableId }) {
    const playerSeat = useGamePlayerSeat(tempTableId);
    const showFold = useShowFold(tempTableId);
    const showCheck = useShowCheck(tempTableId);
    const showCall = useShowCall(tempTableId);
    const showRaise = useShowRaise(tempTableId);
    const showAllIn = useShowAllIn(tempTableId);
    const callAmount = useCallAmount(tempTableId);
    const raiseAmount = useRaiseAmount(tempTableId);
    const showDefaultActions = useShowDefaultActions(tempTableId);
    const playerSitOutTimer = usePlayerSitOutTimer(tempTableId);
    const RITRequest = useRITRequest(tempTableId);
    const showAutoActions = useShowAutoActions(tempTableId);
    const autoCall = useAutoCall(tempTableId);
    const autoCallAny = useAutoCallAny(tempTableId);
    const autoFold = useAutoFold(tempTableId);
    const autoCheck = useAutoCheck(tempTableId);
    const autoCheckOrFold = useAutoCheckOrFold(tempTableId);
    const autoAction = useAutoAction(tempTableId);
    const tourneyAutoPlay = useTourneyAutoPlay(tempTableId);
    const { allInForCall, atTableAmount, isActive } = usePlayerSeat(tempTableId, playerSeat);

    // console.log(showFold, showCheck, showCall, showRaise, showAllIn);

    return (
        <div className={styles.gameActionsRow}>
            {/* Game Play Buttons */}
            {
                showDefaultActions && !tourneyAutoPlay ?
                    <div className={styles.gameButtonsRow}>
                        {showFold && <GameActionButton tempTableId={tempTableId} action={FOLD_ACTION} />}
                        {showCheck && <GameActionButton tempTableId={tempTableId} action={CHECK_ACTION} />}
                        {showCall && !allInForCall && <GameActionButton tempTableId={tempTableId} callAmount={callAmount} action={CALL_ACTION} />}
                        {showRaise && <GameActionButton tempTableId={tempTableId} raiseAmount={raiseAmount} action={RAISE_ACTION} />}
                        {showAllIn && <GameActionButton tempTableId={tempTableId} action={ALL_IN_ACTION} allInForCall={allInForCall} />}
                    </div>
                    :
                    showAutoActions && !tourneyAutoPlay ?
                        <div className={styles.gameButtonsRow}>
                            {autoCheckOrFold && <AutoActionButton active={autoAction === AUTO_CHECK_OR_FOLD_ACTION} tempTableId={tempTableId} action={AUTO_CHECK_OR_FOLD_ACTION} label="C/F" />}
                            {autoFold && <AutoActionButton active={autoAction === AUTO_FOLD_ACTION} tempTableId={tempTableId} action={AUTO_FOLD_ACTION} label="Fold" />}
                            {autoCheck && <AutoActionButton active={autoAction === AUTO_CHECK_ACTION} tempTableId={tempTableId} action={AUTO_CHECK_ACTION} label="Check" />}
                            {autoCall && <AutoActionButton active={autoAction === AUTO_CALL_ACTION} tempTableId={tempTableId} callAmount={callAmount} action={AUTO_CALL_ACTION} label="Call" />}
                            {autoCallAny && <AutoActionButton active={autoAction === AUTO_CALL_ANY_ACTION} tempTableId={tempTableId} action={AUTO_CALL_ANY_ACTION} label="Call Any" />}
                        </div>
                        :
                        null
            }
            {
                RITRequest
                    ?
                    <RITRequestComponent tempTableId={tempTableId} />
                    : null
            }
            <SitOutBottomNotice tempTableId={tempTableId} playerSitOutTimer={playerSitOutTimer} playerSeat={playerSeat} />
            <WatchTimer tempTableId={tempTableId} />
            <TourneyAutoPlayCTA tempTableId={tempTableId} />
            <PlayNext tempTableId={tempTableId} atTableAmount={atTableAmount} isActive={isActive} />
        </div>
    )
}
